module.exports = __webpack_public_path__ + "img/days.c2ada102.svg";